export default "__VITE_ASSET__ICKCPRi9__"